<div [class]="small() === true ? 'small ia-circle' : 'ia-circle'">
  @if(!showInitials()) {
  <p-image width="60" height="60" [src]="photoUrl()"></p-image>
  }
  <canvas [style.display]="showInitials() ? 'auto':'none'" #myCanvas width="40" height="40"></canvas>
</div>